import { Component, OnInit } from "@angular/core";
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexFill,
  NgApexchartsModule
} from "ng-apexcharts";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { DashboardService } from "../../../Services/dashboard.service";
import { apiEndPoints } from "../../../api/apiEndPoint";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-mobile-users',
  standalone: true,
  imports: [NgApexchartsModule, ToastrModule],
  templateUrl: './mobile-users.component.html',
  styleUrl: './mobile-users.component.css'
})
export class MobileUsersComponent implements OnInit {
  allList: any;

  totalUsers:any = {}

  androidUsers:any = {}

  iosUsers:any = {}

  constructor(private dashService: DashboardService, private toastr: ToastrService) {

  }

  ngOnInit() {
    // this.getAllMobileUsersCount();
    this.getMobileUsersData()
  }

  // --------------------------------------- Get All List API --------------------------------------- //

  getAllMobileUsersCount() {
    this.dashService.getDashboardList(apiEndPoints.getDashboardDetails).subscribe({
      next: (response: any) => {
        this.allList = response.body.details;
        console.log(this.allList)
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error('An unexpected error occurred. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }



  chartSeries: ApexNonAxisChartSeries = []; // Percentages for each category

  chartLabels: string[] = ['Requestor', 'Dumpster', 'Dump Yard']; // Define labels for each segment

  chartOptions: ApexChart = {
    type: 'donut', // Donut chart
    height: 350
  };

  title: ApexTitleSubtitle = {
    text: 'On Business',
    align: 'left'
  };

  dataLabels: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    }
  };

  plotOptions: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w) => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
          }
        }
      }
    }
  };

  colors: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fill: ApexFill = {
    type: 'gradient'
  };




  chartSeries2: ApexNonAxisChartSeries = []; // Percentages for each category

  chartLabels2: string[] = ['Requestor', 'Dumpster', 'Dump Yard']; // Define labels for each segment

  chartOptions2: ApexChart = {
    type: 'donut', // Donut chart
    height: 350
  };

  title2: ApexTitleSubtitle = {
    text: 'Off Business',
    align: 'left'
  };

  dataLabels2: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    }
  };

  plotOptions2: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w) => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
          }

        }
      }
    }
  };

  colors2: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fill2: ApexFill = {
    type: 'gradient'
  };


  chartSeries3: ApexNonAxisChartSeries = [750, 5, 3]; // Percentages for each category

  chartLabels3: string[] = ['Requestor', 'Dumpster', 'Dump Yard']; // Define labels for each segment

  chartOptions3: ApexChart = {
    type: 'donut', // Donut chart
    height: 350
  };

  title3: ApexTitleSubtitle = {
    text: 'On Business',
    align: 'left'
  };

  dataLabels3: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    }
  };

  plotOptions3: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w) => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
          }

        }
      }
    }
  };

  colors3: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fill3: ApexFill = {
    type: 'gradient'
  };



  chartSeries4: ApexNonAxisChartSeries = [2265, 22, 5]; // Percentages for each category

  chartLabels4: string[] = ['Requestor', 'Dumpster', 'Dump Yard']; // Define labels for each segment

  chartOptions4: ApexChart = {
    type: 'donut', // Donut chart
    height: 350
  };

  title4: ApexTitleSubtitle = {
    text: 'Off Business',
    align: 'left'
  };

  dataLabels4: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    }

  };

  plotOptions4: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w) => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
          }

        }
      }
    }
  };

  colors4: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fill4: ApexFill = {
    type: 'gradient'
  };


  chartSeries5: ApexNonAxisChartSeries = [33, 2, 15]; // Percentages for each category

  chartLabels5: string[] = ['Requestor', 'Dumpster', 'Dump Yard']; // Define labels for each segment

  chartOptions5: ApexChart = {
    type: 'donut', // Donut chart
    height: 350
  };

  title5: ApexTitleSubtitle = {
    text: 'On Business',
    align: 'left'
  };

  dataLabels5: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    }
  };

  plotOptions5: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w) => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
          }

        }
      }
    }
  };

  colors5: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fill5: ApexFill = {
    type: 'gradient'
  };


  chartSeries6: ApexNonAxisChartSeries = [267, 14, 8]; // Percentages for each category

  chartLabels6: string[] = ['Requestor', 'Dumpster', 'Dump Yard']; // Define labels for each segment

  chartOptions6: ApexChart = {
    type: 'donut', // Donut chart
    height: 350
  };

  title6: ApexTitleSubtitle = {
    text: 'Off Business',
    align: 'left'
  };

  dataLabels6: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    }
  };

  plotOptions6: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Total',
            formatter: (w) => w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0)
          }

        }
      }
    }
  };

  colors6: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fill6: ApexFill = {
    type: 'gradient'
  };

  getMobileUsersData() {
    this.dashService.getDashboardList(apiEndPoints.mobileUsersDashboard).subscribe({
      next: (response: any) => {
        this.totalUsers = response.body.details.totalUsers;
        this.androidUsers = response.body.details.androidUsers;
        console.log(this.androidUsers)
        this.iosUsers = response.body.details.iosUsers;
        this.chartSeries = [
          this.androidUsers.androidOnBusinessUsersSplit.requestorCount,
          this.androidUsers.androidOnBusinessUsersSplit.dumpsterCount,
          this.androidUsers.androidOnBusinessUsersSplit.dumpyardCount
        ]

        this.chartSeries2 = [
          this.androidUsers.androidOffBusinessUsersSplit.requestorCount,
          this.androidUsers.androidOffBusinessUsersSplit.dumpsterCount,
          this.androidUsers.androidOffBusinessUsersSplit.dumpyardCount
        ]

        this.chartSeries3 = [
          this.iosUsers.iOSOnBusinessUsersSplit.requestorCount,
          this.iosUsers.iOSOnBusinessUsersSplit.dumpsterCount,
          this.iosUsers.iOSOnBusinessUsersSplit.dumpyardCount
        ]

        this.chartSeries4 = [
          this.iosUsers.iOSOffBusinessUsersSplit.requestorCount,
          this.iosUsers.iOSOffBusinessUsersSplit.dumpsterCount,
          this.iosUsers.iOSOffBusinessUsersSplit.dumpyardCount
        ]
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error('An unexpected error occurred. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }
}
